import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import BaseIsCustomBadge, {
  IsCustomBadgeProps,
} from "components/Shared/IsCustomBadge";

const fragment = gql(/* GraphQL */ `
  fragment CustomerIsCustomBadge on OrderingPlatform {
    id
    forBrandId
  }
`);

type Fragment = FragmentType<typeof fragment>;

export function getIsOrderingPlatformCustom(orderingPlatform: Fragment) {
  const { forBrandId } = getFragmentData(fragment, orderingPlatform);

  if (forBrandId === undefined) return undefined;

  return forBrandId !== null;
}

type Props = Omit<IsCustomBadgeProps, "isCustom"> & {
  orderingPlatform: Fragment;
};

export default function IsCustomBadge({ orderingPlatform, ...rest }: Props) {
  return (
    <BaseIsCustomBadge
      isCustom={getIsOrderingPlatformCustom(orderingPlatform)}
      {...rest}
    />
  );
}
